import { PageHero } from "../components/PageHero";
import { PackageCard } from "../components/PackageCard";
import { Reveal } from "../components/motion";
import { EnquiryDialog } from "../components/EnquiryDialog";
import { PACKAGES, IMAGES } from "../data/site";

export default function Packages() {
  return (
    <div data-testid="packages-page">
      <PageHero eyebrow="Tour Packages" title={["Mumbai to Kerala,", "beautifully arranged."]}
        subtitle="Handcrafted itineraries covering the hills, backwaters, wildlife and beaches of God's Own Country — each fully customisable."
        image={IMAGES.munnarHero} />
      <section className="max-w-[1400px] mx-auto px-5 lg:px-10 py-24">
        <div className="grid md:grid-cols-3 gap-8">
          {PACKAGES.map((p, i) => <Reveal key={p.slug} delay={i * 0.1}><PackageCard pkg={p} /></Reveal>)}
        </div>
        <Reveal>
          <div className="mt-20 border border-emerald/15 p-10 lg:p-16 text-center bg-white">
            <p className="eyebrow text-gold mb-4">Don't see the perfect fit?</p>
            <h2 className="font-serif text-3xl lg:text-5xl font-light text-emerald max-w-2xl mx-auto leading-tight">Every journey can be tailored to your dates, budget and pace.</h2>
            <div className="mt-8 flex justify-center">
              <EnquiryDialog title="Build My Custom Package" presetType="Custom" trigger={
                <button className="bg-emerald text-cream px-10 py-4 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-gold transition-colors" data-testid="build-custom-btn">Build a Custom Package</button>
              } />
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
